export default __webpack_public_path__ + "static/media/privacyNotice.7e85bb0c.pdf";